var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8125 4.28915C21.6774 2.92867 21.3866 1.4247 20.3164 0.634338C19.4875 0.0214272 18.398 -0.00121612 17.3808 4.24214e-05C15.2308 0.00130096 13.0795 0.0038076 10.9294 0.00506615C8.86135 0.00758323 6.79331 0.00884792 4.72528 0.011365C3.86139 0.0126235 3.02162 -0.0578641 2.21926 0.332284C1.53032 0.667057 0.990993 1.30389 0.66643 2.01245C0.216385 2.99789 0.122279 4.11422 0.0679836 5.20411C-0.0321604 7.18884 -0.0213014 9.17859 0.0981475 11.1621C0.186226 12.6094 0.409435 14.209 1.48206 15.1315C2.43283 15.9483 3.77451 15.9886 5.00761 15.9898C8.92167 15.9936 12.837 15.9974 16.7522 15.9999C17.2541 16.0012 17.7778 15.9911 18.2894 15.9332C19.2956 15.8199 20.2548 15.5191 20.9015 14.7414C21.5543 13.9573 21.722 12.8661 21.821 11.8329C22.0623 9.32583 22.0598 6.79491 21.8125 4.28915ZM8.66589 11.5145V4.48548L14.5008 7.99933L8.66589 11.5145Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6209b3fbe814076fb3da62c3a60a890d.svg";
export { ForwardRef as ReactComponent };